import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CheckboxComponent),
        },
    ],
    standalone: false
})
export class CheckboxComponent implements OnInit {

  @Input() name: string = '';
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  @Input('ngModelValue')
  get ngModelValue(): any {
    return this._ngModelValue;
  }
  set ngModelValue(value: any) {
    if (this._ngModelValue !== value) {
      this._ngModelValue = value;
      this.onChangeCallback(value);
    }
  }

  private _ngModelValue: any = false;
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  constructor() { }

  ngOnInit(): void {
    // checkedが指定されている場合はngModelの値を上書きする
    if (this.checked) {
      this.ngModelValue = true;
    }
  }

  writeValue(selectedValue: any): void {
    if (selectedValue !== this.ngModelValue) {
      this.ngModelValue = selectedValue;
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {}
}
